import { greetingAfterRename, type GreetingUpdate } from '@acs/shared';
import type { BusinessSettingsPatch } from '../../shared/api/businesses.js';
import type { BusinessDoc } from '../../shared/api/converters.js';

/**
 * The one settings write for a rename (doc 68 §1, doc 71), shared by the setup
 * wizard's profile step and Settings › Business.
 *
 * A standard greeting says the business's name out loud, so it moves with the
 * name — in the SAME write, marked `default` so it keeps following every later
 * rename (the publisher and the gateway render it from the current name in any
 * case). The owner's own words are never rewritten; `greeting.mentionsOldName`
 * and `greeting.staleName` let the screen point at them instead.
 */
export function businessRenamePatch(
  business: Pick<BusinessDoc, 'name' | 'greeting' | 'language' | 'greetingMode'>,
  rawName: string,
): { patch: BusinessSettingsPatch; greeting: GreetingUpdate } {
  const name = rawName.trim();
  const greeting = greetingAfterRename(business, name);
  return {
    patch: { name, ...(greeting.kind === 'regenerated' ? { greeting: greeting.greeting, greetingMode: 'default' as const } : {}) },
    greeting,
  };
}
